'use strict';

var gqlUtils = require('@liquorice/gql-utils');
var FIELD_OPTION_FRAGMENT = require('./FIELD_OPTION_FRAGMENT.js');

const useFieldOptions = gqlUtils.createFragmentArrayParser(FIELD_OPTION_FRAGMENT.FIELD_OPTION_FRAGMENT, (data)=>{
    const options = data.map(({ value, label, isDefault })=>({
            value: value != null ? value : '',
            label: label != null ? label : '',
            isDefault: !!isDefault
        }));
    const defaultValues = options.reduce((acc, v)=>{
        if (v.isDefault) {
            acc.push(v.value);
        }
        return acc;
    }, []);
    var _defaultValues_;
    const defaultValue = (_defaultValues_ = defaultValues[0]) != null ? _defaultValues_ : undefined;
    return {
        options,
        defaultValue,
        defaultValues
    };
});

module.exports = useFieldOptions;
